<div
  class="flex flex-wrap items-center gap-x-3 gap-y-2 rounded-lg border p-3 transition-colors"
  [class.border-primary-200]="step().completed"
  [class.bg-primary-50]="step().completed"
  [class.border-greyscale-200]="!step().completed"
  [class.bg-white]="!step().completed"
>
  <button
    type="button"
    role="checkbox"
    [attr.aria-checked]="step().completed"
    [attr.aria-labelledby]="labelId()"
    [disabled]="pending()"
    (click)="onToggle()"
    class="flex h-7 w-7 shrink-0 cursor-pointer items-center justify-center rounded-full border-2 transition-all duration-200"
    [class.border-primary-500]="step().completed"
    [class.bg-primary-500]="step().completed"
    [class.text-white]="step().completed"
    [class.border-greyscale-300]="!step().completed"
    [class.text-transparent]="!step().completed"
    [class.hover:border-primary-400]="!step().completed"
    [class.hover:text-primary-300]="!step().completed"
    [class.opacity-60]="pending()"
  >
    <lucide-icon
      name="check"
      [size]="16"
      [class.animate-check-pop]="step().completed"
    />
  </button>

  <div class="flex min-w-0 flex-1 flex-col gap-0.5">
    <span
      [id]="labelId()"
      class="text-paragraph-s-reg"
      [class.text-greyscale-950]="!step().completed"
      [class.text-greyscale-700]="step().completed"
    >
      {{ "help.onboarding.journey.steps." + step().key | transloco }}
    </span>

    <span
      class="flex items-center gap-1 text-paragraph-xs-reg text-greyscale-500"
    >
      <lucide-icon [name]="trackIcon()" [size]="12" />
      {{ "help.onboarding.journey.tracks." + step().track | transloco }}
    </span>
  </div>

  <app-journey-step-cta [stepKey]="step().key" />
</div>
